import Box from '@/common/components/Box'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import ResumeItem from '@/common/components/ResumeItem'
import { cn } from '@/common/utils/cn'
import ManualEntryProposalsClientAccept from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry/ManualEntryProposals/ClientAccept'
import ManualEntryProposalsClientReject from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry/ManualEntryProposals/ClientReject'
import EstablishmentChoiceEntryProposal from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry/Proposal'
import { maintenanceForwardingsDirectiveEntryKlasses } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { Building2Icon } from 'lucide-react'
import { useMemo } from 'react'

interface MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps {
  showProposalDiagnostic?: boolean
}

const MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection = ({
  showProposalDiagnostic,
}: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps) => {
  const { forwarding, directiveEntryKlass } = useForwardingTabContext()

  const isAwaitingClientResponse = useMemo(() => {
    return forwarding?.establishment_choice_entry?.actual_proposal?.status === 'awaiting_client_response'
  }, [forwarding?.establishment_choice_entry?.actual_proposal?.status])

  return (
    <Box className={cn('p-4 flex flex-col gap-4', isAwaitingClientResponse && 'bg-yellow-op-2')}>
      <div className="flex items-center gap-2 justify-between">
        <div>
          <p className="text-lg font-semibold">
            Estabelecimento para{' '}
            {directiveEntryKlass && maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass]?.label}
          </p>
        </div>

        {isAwaitingClientResponse && forwarding?.establishment_choice_entry.actual_proposal && (
          <div className="flex items-center gap-3">
            <ManualEntryProposalsClientReject proposal={forwarding?.establishment_choice_entry.actual_proposal} />

            <ManualEntryProposalsClientAccept proposal={forwarding?.establishment_choice_entry.actual_proposal} />
          </div>
        )}
      </div>

      <div className="flex items-center gap-3">
        {forwarding?.establishment_choice_entry?.establishment && (
          <ResumeItem
            label="Estabelecimento escolhido"
            value={
              <ImageWithDisplayName
                placeholderIcon={Building2Icon}
                imageUrl={forwarding?.establishment_choice_entry?.establishment.general_information.company_logo?.url}
                displayName={
                  forwarding?.establishment_choice_entry?.establishment.general_information.fantasy_name || '--'
                }
                containerClassName="gap-1.5"
                imageClassName="size-5"
                iconClassName="size-3.5"
                displayNameClassName="text-xs"
              />
            }
            className="text-xs"
            containerClassName="gap-1"
            valueClassName="font-bold text-sm"
          />
        )}
      </div>

      {forwarding?.establishment_choice_entry?.actual_proposal && (
        <EstablishmentChoiceEntryProposal
          proposal={forwarding?.establishment_choice_entry?.actual_proposal}
          showProposalDiagnostic={showProposalDiagnostic}
        />
      )}
    </Box>
  )
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
